var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMonitorIconInverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4442_5321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1 0H5.9C2.64152 0 0 2.64152 0 5.9V74.1C0 77.3585 2.64152 80 5.9 80H74.1C77.3585 80 80 77.3585 80 74.1V5.9C80 2.64152 77.3585 0 74.1 0Z",
    fill: "#202D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.37 49.22C41.2338 49.22 49.23 41.2238 49.23 31.36C49.23 21.4962 41.2338 13.5 31.37 13.5C21.5062 13.5 13.51 21.4962 13.51 31.36C13.51 41.2238 21.5062 49.22 31.37 49.22Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 44L48.84 48.84",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.17 64.0099C65.97 64.4799 65.69 64.9199 65.31 65.3099C63.71 66.8999 61.13 66.8999 59.53 65.3099L48.84 54.6199C47.24 53.0199 47.24 50.4299 48.84 48.8399C49.22 48.4599 49.67 48.1699 50.14 47.9599C50.65 47.7399 51.19 47.6399 51.73 47.6399C52.78 47.6399 53.83 48.0299 54.63 48.8299L65.32 59.5199C66.53 60.7299 66.82 62.5199 66.18 63.9999L66.17 64.0099Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.12 39.5399V35.3999",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.97 39.5399V32.6899",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.81 39.5399V27.1399",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.65 39.5401V23.3601",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4442_5321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIconInverse);
export default __webpack_public_path__ + "static/media/Monitor-Icon-Inverse.40bbfdec713f697efa60a0eee287fb92.svg";
export { ForwardRef as ReactComponent };